// extracted by mini-css-extract-plugin
module.exports = {"titre":"galerie-module--titre--19mhi","soustitre":"galerie-module--soustitre--1-j9R"};